import cn from 'classnames';

import { Link } from 'libs/router/Link';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './HeaderMenu.module.scss';

import type { MenuColumn } from './HeaderMenu.types';

interface Props {
  column: MenuColumn;
  onCloseMenu: () => void;
}

// Two overlapping circles — the universal "compare / overlap" glyph.
const CompareIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={{ width: '1em', height: '1em' }}>
    <circle cx="9" cy="12" r="6.5" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="15" cy="12" r="6.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const CompareColumn = ({ column, onCloseMenu }: Props) => (
  <div className={styles.platformColumn}>
    <div className={styles.featuredBlock}>
      <CompareIcon className={styles.featuredWatermark} />

      <div className={styles.featuredContent}>
        <div className={styles.featuredHeader}>
          <span className={styles.featuredIcon}>
            <CompareIcon />
          </span>
          <p className={styles.featuredTitle}>{column.title}</p>
        </div>

        <div className={styles.compareList}>
          {column.items.map(({ navigation, label, description, disabled }) => (
            <Link
              key={navigation}
              route={navigation}
              className={cn(styles.compareItem, disabled && styles.platformColumnItemDisabled)}
              onClick={onCloseMenu}
            >
              <span className={styles.platformColumnItemText}>
                {label}
                {description && <span className={styles.platformColumnItemDescription}>{description}</span>}
              </span>

              <Icon type="arrow-14" className={styles.companyItemArrow} />
            </Link>
          ))}
        </div>

        <span className={styles.featuredFoot}>Head-to-head, sourced and audited feature by feature.</span>
      </div>
    </div>
  </div>
);
